export default __webpack_public_path__ + "static/media/pic8.fcf5b37a.jpg";